
export type QcReason = {
  code?: string
  message?: string
  [key: string]: unknown
}

export type OrderJobHistory = {
  successful: {count: number} | null
  failed: {reasons: QcReason[]} | null
  created_at: string
}

// Mirrors LumiaJobForLineItemResponse in the order service. `job` is the raw LSJ
// payload the machine consumes -- shape varies by job version, so it stays opaque.
export type OrderJob = {
  id: string
  sku: string
  bundle_index: number
  quantity: number
  quantity_done: number
  quantity_failed: number
  job: Record<string, unknown> | null
  created_at: string
  last_changed_at: string
  job_status: string
  visualization_path: string
  job_histories: OrderJobHistory[] | null
}
export type Order = {
  id: string
  company_id: string
  order_number: string
  external_order_number: string
  order_date: string
  created_at: string
  order_status: OrderStatus
  lumialase_job_call_status: JobCallStatus
  netsuite_status: string
}

export type SingleOrder = { // TODO: Create specific types for key instead of using string
  id: string
  company_id: string
  created_at: string
  lumialase_job_call_status: JobCallStatus
  netsuite_status: string
  order_date: string
  order_details: SingleOrderDetail[]
  order_number: string
  order_status: OrderStatus
  external_order_number: string
}

export enum JobCallStatus {
  NOT_STARTED = "not_started",
  CREATED = "created",
  FAILED = "failed",
}

export enum OrderStatus {
  CREATED = "created",
  DONE = "done",
  CANCELLED = "cancelled",
}

export enum OrderProfanityCheckStatus {
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  NOT_STARTED = "not_started",
  REQUIRES_MANUAL_CHECK = "requires_manual_check",
  NOT_ABLE_TO_CALCULATE = "not_able_to_calculate"
}

export enum TagsFilterTypes {
  FULFILLMENT = 'FULFILLMENT',
  JOB = 'JOB',
}
// One audit row from GET /orders/{id}/history or
// /orders/{id}/line-items/{id}/history. `action_value.value` is not always a
// profanity status -- the backend puts whatever the command changed in there:
// a status string, a section object, or a quantity number.
export type HistoryActionValue = {
  value: OrderProfanityCheckStatus | string | number | Record<string, unknown> | null
  previous?: OrderProfanityCheckStatus | string | number | null
}

export type historyLineItem = {
  id: string
  entity_id: string
  action_type: string
  created_at: string
  user_name: string
  action_value: HistoryActionValue | null
}
export type SingleOrderDetail = {
  id: string
  name: string
  variant_id: string
  image_url: string
  created_at: string
  order_id: string
  quantity: number
  quantity_done: number
  quantity_failed: number
  sections: SingleOrderSection[]
  sku: string
  status: string
  upc: string
  checked:boolean,
  profanity_check_status:string
  visualization:any[]
  is_bundle:boolean
  lumialase_job_call_status:string
  jobs:OrderJob[]
  visualization_path:string
  product:any
}
type ElementType = 'custom' | 'listTexts' | string;

type Element = {
  type: ElementType;
  custom?: { rawImage?: string };
  listTexts?: { list: { image?: string }[] | null };
  [key: string]: any;
};
export type SnapshotViewport = {
  width?: number
  height?: number
  product_margin?: number | null
  fit_mode?: 'product' | 'current_view' | string
}

export type SingleOrderSection = {
  artwork_coordinates: Coordinate
  artwork_dimensions: Dimension
  name: string
  radial_angle: number
  section_angle: number
  section_artwork_url: string
  section_coordinates: Coordinate
  section_dimensions: Dimension
  snapshot: string
  bundle_index: number
  elements:Element
  raw_images: RawImage[]
  product_sku:string
  snapshot_viewport?: SnapshotViewport
}

type RawImage = {
  element_raw_image: string
  profanity_check_result: OrderProfanityCheckResult
}

type OrderProfanityCheckResult = {
  rsp: OrderProfanityRsp
}

type OrderProfanityRsp = {
  alcohol: string
  artificialText: string
  categories: string
  drugs: string
  format: string
  gore: string
  method: string
  naturaltext: string
  nudity: string
  nuditypartial: string
  nuditysafe: string
  offensive: string
  scam: string
  weapon: string
}

type Coordinate = {
  x: number
  y: number
}

type Dimension = {
  width: number
  height: number
}
